/**
 * Français — SCAFFOLDING ONLY. Every value is the `FR_PENDING` sentinel on
 * purpose: the brief says build the FR scaffolding but do NOT machine-fill it,
 * so nothing in here pretends to be a translation.
 *
 * The type is `Record<TranslationKey, typeof FR_PENDING>` — a literal type.
 * Dropping a machine translation into a value therefore fails `tsc`, which is
 * the point: FR text enters this file only when a human writes it and widens
 * the type in the same commit.
 *
 * Until then the UI shows FR as "ausstehend", falls back to DE and says so.
 */
import type { TranslationKey } from './de'

export const FR_PENDING = '__FR_PENDING__'

export const fr: Record<TranslationKey, typeof FR_PENDING> = {
  'app.name': FR_PENDING,
  'app.attribution': FR_PENDING,
  'app.tagline': FR_PENDING,
  'nav.dossiers': FR_PENDING,
  'nav.report': FR_PENDING,
  'nav.run': FR_PENDING,
  'lang.label': FR_PENDING,
  'lang.de': FR_PENDING,
  'lang.en': FR_PENDING,
  'lang.fr': FR_PENDING,
  'lang.frPending': FR_PENDING,
  'lang.frBanner': FR_PENDING,
  'a11y.skipToContent': FR_PENDING,
  'title.home': FR_PENDING,
  'title.signIn': FR_PENDING,
  'title.invite': FR_PENDING,
  'title.workspaceIndex': FR_PENDING,
  'title.workspace': FR_PENDING,
  'title.upload': FR_PENDING,
  'title.facts': FR_PENDING,
  'title.dossierAudit': FR_PENDING,
  'title.admin': FR_PENDING,
  'title.rulebase': FR_PENDING,
  'title.rulebaseIngest': FR_PENDING,
  'title.rulebaseIngestion': FR_PENDING,
  'title.rulebasePack': FR_PENDING,
  'title.run': FR_PENDING,
  'title.report': FR_PENDING,
  'title.reportPrint': FR_PENDING,
  'title.notFound': FR_PENDING,
  'common.loading': FR_PENDING,
  'common.error': FR_PENDING,
  'common.retry': FR_PENDING,
  'common.back': FR_PENDING,
  'common.none': FR_PENDING,
  'common.of': FR_PENDING,
  'common.yes': FR_PENDING,
  'common.no': FR_PENDING,
  'common.cancel': FR_PENDING,
  'start.title': FR_PENDING,
  'start.lead': FR_PENDING,
  'start.dossiersTitle': FR_PENDING,
  'start.dossiersLead': FR_PENDING,
  'start.dossiersEmpty': FR_PENDING,
  'start.synthetic': FR_PENDING,
  'start.startRun': FR_PENDING,
  'start.starting': FR_PENDING,
  'start.gemeindenTitle': FR_PENDING,
  'start.gemeindenLead': FR_PENDING,
  'start.gemeindenEmpty': FR_PENDING,
  'coverage.zones': FR_PENDING,
  'coverage.rules': FR_PENDING,
  'coverage.verified': FR_PENDING,
  'coverage.unverified': FR_PENDING,
  'coverage.placeholder': FR_PENDING,
  'coverage.regime': FR_PENDING,
  'coverage.sources': FR_PENDING,
  'coverage.mode.verified': FR_PENDING,
  'coverage.mode.indicative': FR_PENDING,
  'run.title': FR_PENDING,
  'run.lead': FR_PENDING,
  'run.id': FR_PENDING,
  'run.dossier': FR_PENDING,
  'run.stagesTitle': FR_PENDING,
  'run.openReport': FR_PENDING,
  'run.failedTitle': FR_PENDING,
  'run.pollError': FR_PENDING,
  'run.statusLabel': FR_PENDING,
  'run.status.queued': FR_PENDING,
  'run.status.running': FR_PENDING,
  'run.status.succeeded': FR_PENDING,
  'run.status.failed': FR_PENDING,
  'run.elapsed': FR_PENDING,
  'run.longRunning': FR_PENDING,
  'stage.pending': FR_PENDING,
  'stage.running': FR_PENDING,
  'stage.done': FR_PENDING,
  'stage.skipped': FR_PENDING,
  'stage.failed': FR_PENDING,
  'report.title': FR_PENDING,
  'report.gemeinde': FR_PENDING,
  'report.zone': FR_PENDING,
  'report.regime': FR_PENDING,
  'report.case': FR_PENDING,
  'report.mode': FR_PENDING,
  'report.ampelTitle': FR_PENDING,
  'report.ampelLead': FR_PENDING,
  'report.findingsTitle': FR_PENDING,
  'report.findingsLead': FR_PENDING,
  'report.findingsEmpty': FR_PENDING,
  'report.indicativeTitle': FR_PENDING,
  'report.indicativeLead': FR_PENDING,
  'report.indicativeBadge': FR_PENDING,
  'report.indicativeEmpty': FR_PENDING,
  'report.indicativeReason': FR_PENDING,
  'report.modeIndicativeBanner': FR_PENDING,
  'report.hinweiseTitle': FR_PENDING,
  'report.hinweiseLead': FR_PENDING,
  'report.hinweisBadge': FR_PENDING,
  'report.confidence': FR_PENDING,
  'report.nachweiseTitle': FR_PENDING,
  'report.nachweiseLead': FR_PENDING,
  'report.nachweisDue': FR_PENDING,
  'report.nachweisOpen': FR_PENDING,
  'report.nachweisDone': FR_PENDING,
  'report.skippedTitle': FR_PENDING,
  'report.skippedLead': FR_PENDING,
  'report.skippedReason': FR_PENDING,
  'report.skippedGroup.missingInput': FR_PENDING,
  'report.skippedGroup.missingInputLead': FR_PENDING,
  'report.skippedGroup.missingGis': FR_PENDING,
  'report.skippedGroup.missingGisLead': FR_PENDING,
  'report.skippedGroup.notComputable': FR_PENDING,
  'report.skippedGroup.notComputableLead': FR_PENDING,
  'report.skippedGroup.unverified': FR_PENDING,
  'report.skippedGroup.unverifiedLead': FR_PENDING,
  'report.skippedGroup.other': FR_PENDING,
  'report.skippedGroup.otherLead': FR_PENDING,
  'report.skippedGroup.notApplicable': FR_PENDING,
  'report.skippedGroup.notApplicableLead': FR_PENDING,
  'report.grenzenTitle': FR_PENDING,
  'report.grenzenLead': FR_PENDING,
  'report.rule': FR_PENDING,
  'report.source': FR_PENDING,
  'report.pack': FR_PENDING,
  'report.computed': FR_PENDING,
  'report.missing': FR_PENDING,
  'report.newRun': FR_PENDING,
  'report.loadError': FR_PENDING,
  'report.asOf': FR_PENDING,
  'report.actionTitle': FR_PENDING,
  'report.skippedEmpty': FR_PENDING,
  'report.nachweiseEmpty': FR_PENDING,
  'report.hinweiseEmpty': FR_PENDING,
  'report.grenzenEmpty': FR_PENDING,
  'report.sourcesTitle': FR_PENDING,
  'report.sourcesLead': FR_PENDING,
  'report.sourcesEmpty': FR_PENDING,
  'report.sourceNoVersion': FR_PENDING,
  'report.printView': FR_PENDING,
  'report.pdfDownload': FR_PENDING,
  'confidence.deterministic': FR_PENDING,
  'confidence.retrieval': FR_PENDING,
  'confidence.indicator': FR_PENDING,
  'confidence.level.high': FR_PENDING,
  'confidence.level.medium': FR_PENDING,
  'confidence.level.low': FR_PENDING,
  'confidence.deterministic.meaning': FR_PENDING,
  'confidence.retrieval.meaning': FR_PENDING,
  'confidence.indicator.meaning': FR_PENDING,
  'action.green': FR_PENDING,
  'action.missingArtifacts': FR_PENDING,
  'action.missingFormFields': FR_PENDING,
  'action.inconsistent': FR_PENDING,
  'action.gisFlag': FR_PENDING,
  'action.limitNotMet': FR_PENDING,
  'action.generic': FR_PENDING,
  'action.indicative': FR_PENDING,
  'explainer.title': FR_PENDING,
  'explainer.lead': FR_PENDING,
  'explainer.show': FR_PENDING,
  'explainer.hide': FR_PENDING,
  'explainer.lights.title': FR_PENDING,
  'explainer.lights.body': FR_PENDING,
  'explainer.lights.note': FR_PENDING,
  'explainer.confidence.title': FR_PENDING,
  'explainer.confidence.body': FR_PENDING,
  'explainer.confidence.deterministic': FR_PENDING,
  'explainer.confidence.retrieval': FR_PENDING,
  'explainer.confidence.indicator': FR_PENDING,
  'explainer.numbers.title': FR_PENDING,
  'explainer.numbers.body': FR_PENDING,
  'explainer.numbers.example': FR_PENDING,
  'explainer.skipped.title': FR_PENDING,
  'explainer.skipped.body': FR_PENDING,
  'explainer.indicative.title': FR_PENDING,
  'explainer.indicative.body': FR_PENDING,
  'explainer.nachweise.title': FR_PENDING,
  'explainer.nachweise.body': FR_PENDING,
  'explainer.liability.title': FR_PENDING,
  'explainer.liability.body': FR_PENDING,
  'print.date': FR_PENDING,
  'print.page': FR_PENDING,
  'print.footnote': FR_PENDING,
  'severity.red': FR_PENDING,
  'severity.amber': FR_PENDING,
  'severity.green': FR_PENDING,
  'severity.red.meaning': FR_PENDING,
  'severity.amber.meaning': FR_PENDING,
  'severity.green.meaning': FR_PENDING,
  'auth.title': FR_PENDING,
  'auth.lead': FR_PENDING,
  'auth.redeeming': FR_PENDING,
  'auth.linkFailedTitle': FR_PENDING,
  'auth.linkFailedNext': FR_PENDING,
  'auth.requestTitle': FR_PENDING,
  'auth.emailLabel': FR_PENDING,
  'auth.emailPlaceholder': FR_PENDING,
  'auth.requestAction': FR_PENDING,
  'auth.requesting': FR_PENDING,
  'auth.mailNotice.delivers': FR_PENDING,
  'auth.mailNotice.logOnly': FR_PENDING,
  'auth.signOut': FR_PENDING,
  'invite.title': FR_PENDING,
  'invite.redeeming': FR_PENDING,
  'invite.noToken': FR_PENDING,
  'invite.failedTitle': FR_PENDING,
  'invite.failedNext': FR_PENDING,
  'invite.toSignIn': FR_PENDING,
  'invite.state.open': FR_PENDING,
  'invite.state.accepted': FR_PENDING,
  'invite.state.revoked': FR_PENDING,
  'invite.state.expired': FR_PENDING,
  'invitePanel.title': FR_PENDING,
  'invitePanel.lead': FR_PENDING,
  'invitePanel.emailLabel': FR_PENDING,
  'invitePanel.roleLabel': FR_PENDING,
  'invitePanel.roleMember': FR_PENDING,
  'invitePanel.roleAdmin': FR_PENDING,
  'invitePanel.create': FR_PENDING,
  'invitePanel.linkOnce': FR_PENDING,
  'invitePanel.copy': FR_PENDING,
  'invitePanel.noMail': FR_PENDING,
  'invitePanel.mailSent': FR_PENDING,
  'invitePanel.revoke': FR_PENDING,
  'invitePanel.empty': FR_PENDING,
  'workspace.switchLabel': FR_PENDING,
  'workspace.switchNone': FR_PENDING,
  'workspace.indexLink': FR_PENDING,
  'workspace.role': FR_PENDING,
  'workspace.role.founder': FR_PENDING,
  'workspace.role.admin': FR_PENDING,
  'workspace.role.member': FR_PENDING,
  'workspace.uploadCta': FR_PENDING,
  'workspace.dossiersTitle': FR_PENDING,
  'workspace.dossiersLead': FR_PENDING,
  'workspace.dossiersEmpty': FR_PENDING,
  'workspace.kindUpload': FR_PENDING,
  'workspace.kindDemo': FR_PENDING,
  'workspace.attested': FR_PENDING,
  'workspace.notFound': FR_PENDING,
  'workspace.retention': FR_PENDING,
  'workspace.window.title': FR_PENDING,
  'workspace.window.lead': FR_PENDING,
  'workspace.window.label': FR_PENDING,
  'workspace.window.optional': FR_PENDING,
  'workspace.window.save': FR_PENDING,
  'workspace.window.asymmetry': FR_PENDING,
  'workspace.window.saved': FR_PENDING,
  'workspace.window.backups': FR_PENDING,
  'workspace.window.confirm.title': FR_PENDING,
  'workspace.window.confirm.change': FR_PENDING,
  'workspace.window.confirm.due': FR_PENDING,
  'workspace.window.confirm.dueNone': FR_PENDING,
  'workspace.window.confirm.redated': FR_PENDING,
  'workspace.window.confirm.what': FR_PENDING,
  'workspace.window.confirm.unknown': FR_PENDING,
  'workspace.window.confirm.cta': FR_PENDING,
  'workspace.window.confirm.busy': FR_PENDING,
  'workspace.mode.label': FR_PENDING,
  'workspace.mode.title': FR_PENDING,
  'workspace.mode.lead': FR_PENDING,
  'workspace.mode.current': FR_PENDING,
  'workspace.mode.locked': FR_PENDING,
  'workspace.mode.lockedReason': FR_PENDING,
  'workspace.mode.liveLockedReason': FR_PENDING,
  'workspace.mode.unknown': FR_PENDING,
  'workspace.mode.demo': FR_PENDING,
  'workspace.mode.anonymised': FR_PENDING,
  'workspace.mode.live': FR_PENDING,
  'workspace.mode.demoHint': FR_PENDING,
  'workspace.mode.anonymisedHint': FR_PENDING,
  'workspace.mode.liveHint': FR_PENDING,
  'workspace.mode.liveHintUs': FR_PENDING,
  'workspaceIndex.title': FR_PENDING,
  'workspaceIndex.leadFounder': FR_PENDING,
  'workspaceIndex.leadMember': FR_PENDING,
  'workspaceIndex.emptyFounder': FR_PENDING,
  'workspaceIndex.emptyMember': FR_PENDING,
  'workspaceIndex.createTitle': FR_PENDING,
  'workspaceIndex.createLead': FR_PENDING,
  'workspaceIndex.nameLabel': FR_PENDING,
  'workspaceIndex.create': FR_PENDING,
  'upload.title': FR_PENDING,
  'upload.lead': FR_PENDING,
  'upload.filesTitle': FR_PENDING,
  'upload.caps': FR_PENDING,
  'upload.dropHere': FR_PENDING,
  'upload.orChoose': FR_PENDING,
  'upload.accepted': FR_PENDING,
  'upload.noFiles': FR_PENDING,
  'upload.summary': FR_PENDING,
  'upload.removeFile': FR_PENDING,
  'upload.contextTitle': FR_PENDING,
  'upload.contextLead': FR_PENDING,
  'upload.gemeinde': FR_PENDING,
  'upload.bautyp': FR_PENDING,
  'upload.verfahren': FR_PENDING,
  'upload.pleaseChoose': FR_PENDING,
  'upload.zone': FR_PENDING,
  'upload.zonePlaceholder': FR_PENDING,
  'upload.dossierTitle': FR_PENDING,
  'upload.dossierTitlePlaceholder': FR_PENDING,
  'upload.missingGemeinde': FR_PENDING,
  'upload.attestTitle': FR_PENDING,
  'upload.attestLead': FR_PENDING,
  'upload.attestCheckbox': FR_PENDING,
  'upload.attestHelp': FR_PENDING,
  'upload.attestCheckboxLiveUs': FR_PENDING,
  'upload.attestCheckboxLiveLocal': FR_PENDING,
  'upload.attestHelpLive': FR_PENDING,
  'upload.submit': FR_PENDING,
  'upload.submitting': FR_PENDING,
  'upload.blockedAttest': FR_PENDING,
  'upload.blockedFiles': FR_PENDING,
  'upload.blockedGemeinde': FR_PENDING,
  'upload.reject.notPdf': FR_PENDING,
  'upload.reject.tooLarge': FR_PENDING,
  'upload.reject.totalTooLarge': FR_PENDING,
  'upload.reject.tooMany': FR_PENDING,
  'upload.reject.duplicate': FR_PENDING,
  'upload.reject.empty': FR_PENDING,
  'upload.bautyp.neubau': FR_PENDING,
  'upload.bautyp.umbau': FR_PENDING,
  'upload.bautyp.anbau': FR_PENDING,
  'upload.bautyp.aufstockung': FR_PENDING,
  'upload.bautyp.abbruch-wiederaufbau': FR_PENDING,
  'upload.bautyp.ersatzneubau': FR_PENDING,
  'upload.verfahren.ordentlich': FR_PENDING,
  'upload.verfahren.vereinfacht': FR_PENDING,
  'upload.verfahren.anzeigeverfahren': FR_PENDING,
  'run.llmBlocked': FR_PENDING,
  'run.isRecheck': FR_PENDING,
  'run.openParent': FR_PENDING,
  'report.isRecheck': FR_PENDING,
  'report.openParentReport': FR_PENDING,
  'facts.cta': FR_PENDING,
  'facts.title': FR_PENDING,
  'facts.lead': FR_PENDING,
  'facts.openReport': FR_PENDING,
  'facts.recheckNow': FR_PENDING,
  'facts.llmStatus': FR_PENDING,
  'facts.noFactsYet': FR_PENDING,
  'facts.empty': FR_PENDING,
  'facts.valueMissing': FR_PENDING,
  'facts.edit': FR_PENDING,
  'facts.enter': FR_PENDING,
  'facts.save': FR_PENDING,
  'facts.clear': FR_PENDING,
  'facts.editHelp': FR_PENDING,
  'facts.listHelp': FR_PENDING,
  'facts.listPlaceholder': FR_PENDING,
  'facts.notEditable': FR_PENDING,
  'facts.notEditableGis': FR_PENDING,
  'facts.saving': FR_PENDING,
  'facts.rechecking': FR_PENDING,
  'facts.recheckTitle': FR_PENDING,
  'facts.recheckMeta': FR_PENDING,
  'facts.confidence': FR_PENDING,
  'facts.prov.deterministisch': FR_PENDING,
  'facts.prov.deterministisch.meaning': FR_PENDING,
  'facts.prov.llm': FR_PENDING,
  'facts.prov.llm.meaning': FR_PENDING,
  'facts.prov.gis': FR_PENDING,
  'facts.prov.gis.meaning': FR_PENDING,
  'facts.prov.manuell': FR_PENDING,
  'facts.prov.manuell.meaning': FR_PENDING,
  'facts.prov.unbekannt': FR_PENDING,
  'facts.prov.unbekannt.meaning': FR_PENDING,
  'facts.missingTitle': FR_PENDING,
  'facts.missingLead': FR_PENDING,
  'facts.missingEmpty': FR_PENDING,
  'facts.missingNoneBlocking': FR_PENDING,
  'facts.missingRest': FR_PENDING,
  'facts.missingRestOne': FR_PENDING,
  'facts.missingRestLead': FR_PENDING,
  'facts.blocks': FR_PENDING,
  'facts.blocksNone': FR_PENDING,
  'facts.jumpToField': FR_PENDING,
  'facts.group.stammdaten': FR_PENDING,
  'facts.group.values': FR_PENDING,
  'facts.group.form': FR_PENDING,
  'facts.group.flags': FR_PENDING,
  'facts.group.gis': FR_PENDING,
  'facts.group.dokumente': FR_PENDING,
  'facts.group.nachweise': FR_PENDING,
  'facts.filesTitle': FR_PENDING,
  'facts.pages': FR_PENDING,
  'facts.kind.vector': FR_PENDING,
  'facts.kind.raster': FR_PENDING,
  'facts.kind.mixed': FR_PENDING,
  'facts.kind.unknown': FR_PENDING,
  'notices.title': FR_PENDING,
  'notices.runTitle': FR_PENDING,
  'notices.reportTitle': FR_PENDING,
  'notices.recheckTitle': FR_PENDING,
  'notices.stage': FR_PENDING,
  'diff.title': FR_PENDING,
  'diff.sectionTitle': FR_PENDING,
  'diff.sectionLead': FR_PENDING,
  'diff.factsTitle': FR_PENDING,
  'diff.findingsTitle': FR_PENDING,
  'diff.change.neu': FR_PENDING,
  'diff.change.entfallen': FR_PENDING,
  'diff.change.schwere': FR_PENDING,
  'diff.change.wert': FR_PENDING,
  'diff.wasAbsent': FR_PENDING,
  'diff.isGone': FR_PENDING,
  'diff.moved': FR_PENDING,
  'diff.unchanged': FR_PENDING,
  'cost.title': FR_PENDING,
  'cost.input': FR_PENDING,
  'cost.output': FR_PENDING,
  'cost.calls': FR_PENDING,
  'cost.budget': FR_PENDING,
  'cost.exceeded': FR_PENDING,
  'nav.rulebase': FR_PENDING,
  'rulebase.title': FR_PENDING,
  'rulebase.lead': FR_PENDING,
  'rulebase.summary': FR_PENDING,
  'rulebase.summaryOne': FR_PENDING,
  'rulebase.empty': FR_PENDING,
  'rulebase.draftBadge': FR_PENDING,
  'rulebase.draftNote': FR_PENDING,
  'rulebase.verifiedBadge': FR_PENDING,
  'rulebase.verifiedBadgeCount': FR_PENDING,
  'rulebase.openCountBadge': FR_PENDING,
  'packDetail.lead': FR_PENDING,
  'packDetail.coverageTitle': FR_PENDING,
  'packDetail.hoehenregime': FR_PENDING,
  'packDetail.bzoVersion': FR_PENDING,
  'packDetail.loadError': FR_PENDING,
  'packDetail.zonesTitle': FR_PENDING,
  'packDetail.zonesLead': FR_PENDING,
  'packDetail.zonesEmpty': FR_PENDING,
  'packDetail.zonesCaption': FR_PENDING,
  'packDetail.zoneCode': FR_PENDING,
  'packDetail.zoneStatus': FR_PENDING,
  'packDetail.zoneParameters': FR_PENDING,
  'packDetail.zoneAliases': FR_PENDING,
  'packDetail.zoneRegime': FR_PENDING,
  'packDetail.zoneNoParameters': FR_PENDING,
  'packDetail.zoneVerifiedFrom': FR_PENDING,
  'packDetail.zoneVerifiedOn': FR_PENDING,
  'packDetail.zoneHeldBack': FR_PENDING,
  'packDetail.zoneNull': FR_PENDING,
  'packDetail.layersTitle': FR_PENDING,
  'packDetail.layersLead': FR_PENDING,
  'packDetail.layersEmpty': FR_PENDING,
  'packDetail.layerRules': FR_PENDING,
  'packDetail.layerRulesOne': FR_PENDING,
  'packDetail.ruleType': FR_PENDING,
  'packDetail.ruleType.computable': FR_PENDING,
  'packDetail.ruleType.required': FR_PENDING,
  'packDetail.ruleType.nachweis': FR_PENDING,
  'packDetail.ruleType.narrative': FR_PENDING,
  'packDetail.ruleChecks': FR_PENDING,
  'packDetail.ruleNoCheck': FR_PENDING,
  'packDetail.ruleSeverity': FR_PENDING,
  'packDetail.ruleInputs': FR_PENDING,
  'packDetail.ruleAppliesTo': FR_PENDING,
  'packDetail.ruleVerifyNote': FR_PENDING,
  'packDetail.ruleVorbehalt': FR_PENDING,
  'packDetail.ruleUnverified': FR_PENDING,
  'packDetail.ruleIdsNote': FR_PENDING,
  'rulebase.draftSectionTitle': FR_PENDING,
  'rulebase.verifiedSectionTitle': FR_PENDING,
  'rulebase.zones': FR_PENDING,
  'rulebase.zoneParameters': FR_PENDING,
  'rulebase.rules': FR_PENDING,
  'rulebase.verified': FR_PENDING,
  'rulebase.open': FR_PENDING,
  'rulebase.sources': FR_PENDING,
  'rulebase.noSources': FR_PENDING,
  'rulebase.pages': FR_PENDING,
  'rulebase.ingestedAt': FR_PENDING,
  'rulebase.openPack': FR_PENDING,
  'rulebase.openPackVerified': FR_PENDING,
  'rulebase.noPackFor': FR_PENDING,
  'rulebase.ingestCta': FR_PENDING,
  'rulebase.ingestTitle': FR_PENDING,
  'rulebase.ingestLead': FR_PENDING,
  'rulebase.ingestGemeinde': FR_PENDING,
  'rulebase.ingestGemeindePlaceholder': FR_PENDING,
  'rulebase.ingestKanton': FR_PENDING,
  'rulebase.ingestFileTitle': FR_PENDING,
  'rulebase.ingestDropHere': FR_PENDING,
  'rulebase.ingestOrChoose': FR_PENDING,
  'rulebase.ingestNoFile': FR_PENDING,
  'rulebase.ingestNotPdf': FR_PENDING,
  'rulebase.ingestFileDescription': FR_PENDING,
  'rulebase.ingestTooLarge': FR_PENDING,
  'rulebase.ingestSubmit': FR_PENDING,
  'rulebase.ingestSubmitting': FR_PENDING,
  'rulebase.ingestBlockedFile': FR_PENDING,
  'rulebase.ingestBlockedGemeinde': FR_PENDING,
  'rulebase.ingestReplaceTitle': FR_PENDING,
  'rulebase.ingestReplace': FR_PENDING,
  'rulebase.ingestScopeNote': FR_PENDING,
  'rulebase.ingestAttestTitle': FR_PENDING,
  'rulebase.ingestAttestCheckbox': FR_PENDING,
  'rulebase.ingestBlockedAttest': FR_PENDING,
  'rulebase.ingestionTitle': FR_PENDING,
  'rulebase.ingestionLead': FR_PENDING,
  'rulebase.ingestionStagesTitle': FR_PENDING,
  'rulebase.ingestionFailed': FR_PENDING,
  'rulebase.ingestionPollError': FR_PENDING,
  'rulebase.ingestionOpenPack': FR_PENDING,
  'rulebase.ingestionGemeinde': FR_PENDING,
  'rulebase.shadowedSectionTitle': FR_PENDING,
  'rulebase.shadowedTitle': FR_PENDING,
  'rulebase.shadowedLead': FR_PENDING,
  'rulebase.conflicts': FR_PENDING,
  'verify.title': FR_PENDING,
  'verify.lead': FR_PENDING,
  'verify.packNotFound': FR_PENDING,
  'verify.exportCta': FR_PENDING,
  'verify.exportHint': FR_PENDING,
  'verify.zonesTitle': FR_PENDING,
  'verify.zonesLead': FR_PENDING,
  'verify.rulesTitle': FR_PENDING,
  'verify.rulesLead': FR_PENDING,
  'verify.zonesEmpty': FR_PENDING,
  'verify.rulesEmpty': FR_PENDING,
  'verify.noWholePack': FR_PENDING,
  'verify.founderOnlyNote': FR_PENDING,
  'verify.founderOnlyRow': FR_PENDING,
  'verify.extracted': FR_PENDING,
  'verify.sourceTitle': FR_PENDING,
  'verify.page': FR_PENDING,
  'verify.pageUnknown': FR_PENDING,
  'verify.openSource': FR_PENDING,
  'verify.noSourceLink': FR_PENDING,
  'verify.noCitation': FR_PENDING,
  'verify.sameSource': FR_PENDING,
  'verify.expand': FR_PENDING,
  'verify.collapse': FR_PENDING,
  'verify.zoneRowItem': FR_PENDING,
  'verify.zoneRowItemHint': FR_PENDING,
  'verify.disposition': FR_PENDING,
  'verify.evidenceFor': FR_PENDING,
  'verify.confirm': FR_PENDING,
  'verify.correct': FR_PENDING,
  'verify.unreadable': FR_PENDING,
  'verify.unreadableHint': FR_PENDING,
  'verify.newValue': FR_PENDING,
  'verify.newValuePlaceholder': FR_PENDING,
  'verify.notRead': FR_PENDING,
  'verify.ratioBoth': FR_PENDING,
  'verify.ratioOpen': FR_PENDING,
  'verify.readAs': FR_PENDING,
  'verify.markAllConfirmed': FR_PENDING,
  'verify.markAllHint': FR_PENDING,
  'verify.submitRow': FR_PENDING,
  'verify.submitRowOne': FR_PENDING,
  'verify.submitRowNone': FR_PENDING,
  'verify.submitting': FR_PENDING,
  'verify.rowSaved': FR_PENDING,
  'verify.rowError': FR_PENDING,
  'verify.correctionNeedsValue': FR_PENDING,
  'verify.status.verified': FR_PENDING,
  'verify.status.unverified': FR_PENDING,
  'verify.status.placeholder': FR_PENDING,
  'verify.progress': FR_PENDING,
  'verify.ruleKind': FR_PENDING,
  'verify.ruleKindUnknown': FR_PENDING,
  'verify.ruleCheckTitle': FR_PENDING,
  'verify.ruleNoCheck': FR_PENDING,
  'verify.ruleOp': FR_PENDING,
  'verify.ruleValue': FR_PENDING,
  'verify.ruleValuePlaceholder': FR_PENDING,
  'verify.ruleArtifact': FR_PENDING,
  'verify.ruleReject': FR_PENDING,
  'verify.ruleRejectHint': FR_PENDING,
  'verify.ruleSubmit': FR_PENDING,
  'verify.ruleNeedsCheck': FR_PENDING,
  // ── M5 ────────────────────────────────────────────────────────────────
  'retention.title': FR_PENDING,
  'retention.window': FR_PENDING,
  'retention.note': FR_PENDING,
  'retention.deleteOn': FR_PENDING,
  'retention.deleteIn': FR_PENDING,
  'retention.deleteToday': FR_PENDING,
  'retention.due': FR_PENDING,
  'retention.none': FR_PENDING,
  'delete.cta': FR_PENDING,
  'delete.title': FR_PENDING,
  'delete.what': FR_PENDING,
  'delete.irreversible': FR_PENDING,
  'delete.keeps': FR_PENDING,
  'delete.confirm': FR_PENDING,
  'delete.cancel': FR_PENDING,
  'delete.busy': FR_PENDING,
  'delete.done': FR_PENDING,
  'dossierAudit.cta': FR_PENDING,
  'dossierAudit.title': FR_PENDING,
  'dossierAudit.lead': FR_PENDING,
  'dossierAudit.back': FR_PENDING,
  'audit.when': FR_PENDING,
  'audit.who': FR_PENDING,
  'audit.what': FR_PENDING,
  'audit.detail': FR_PENDING,
  'audit.empty': FR_PENDING,
  'audit.system': FR_PENDING,
  'audit.redacted': FR_PENDING,
  'audit.action.auth.sign_in': FR_PENDING,
  'audit.action.auth.sign_out': FR_PENDING,
  'audit.action.invite.created': FR_PENDING,
  'audit.action.invite.revoked': FR_PENDING,
  'audit.action.invite.accepted': FR_PENDING,
  'audit.action.workspace.created': FR_PENDING,
  'audit.action.workspace.data_mode_changed': FR_PENDING,
  'audit.action.workspace.deleted': FR_PENDING,
  'audit.action.dossier.uploaded': FR_PENDING,
  'audit.action.dossier.fact_edited': FR_PENDING,
  'audit.action.dossier.deleted': FR_PENDING,
  'audit.action.run.started': FR_PENDING,
  'audit.action.run.finished': FR_PENDING,
  'audit.action.report.exported': FR_PENDING,
  'audit.action.rulebase.bzo_ingested': FR_PENDING,
  'audit.action.rulebase.zone_verified': FR_PENDING,
  'audit.action.rulebase.rule_verified': FR_PENDING,
  'audit.action.rulebase.pack_exported': FR_PENDING,
  'audit.action.retention.swept': FR_PENDING,
  'nav.admin': FR_PENDING,
  'admin.title': FR_PENDING,
  'admin.lead': FR_PENDING,
  'admin.forbidden': FR_PENDING,
  'admin.workspacesTitle': FR_PENDING,
  'admin.workspacesCaption': FR_PENDING,
  'admin.col.workspace': FR_PENDING,
  'admin.col.dataMode': FR_PENDING,
  'admin.col.members': FR_PENDING,
  'admin.col.dossiers': FR_PENDING,
  'admin.col.runs': FR_PENDING,
  'admin.col.failed': FR_PENDING,
  'admin.col.files': FR_PENDING,
  'admin.col.storage': FR_PENDING,
  'admin.col.drafts': FR_PENDING,
  'admin.col.lastRun': FR_PENDING,
  'admin.col.tokens': FR_PENDING,
  'admin.col.tokensDay': FR_PENDING,
  'admin.col.retention': FR_PENDING,
  'admin.col.due': FR_PENDING,
  'admin.col.status': FR_PENDING,
  'admin.col.mode': FR_PENDING,
  'admin.col.duration': FR_PENDING,
  'admin.col.started': FR_PENDING,
  'admin.col.gemeinde': FR_PENDING,
  'admin.col.open': FR_PENDING,
  'admin.totals': FR_PENDING,
  'admin.dayBudgetReached': FR_PENDING,
  'admin.dayBudgetLead': FR_PENDING,
  'admin.runsTitle': FR_PENDING,
  'admin.runsCaption': FR_PENDING,
  'admin.runsEmpty': FR_PENDING,
  'admin.openRun': FR_PENDING,
  'admin.queueTitle': FR_PENDING,
  'admin.queueLead': FR_PENDING,
  'admin.queueEmpty': FR_PENDING,
  'admin.queueOpen': FR_PENDING,
  'admin.queueRefused': FR_PENDING,
  'admin.queueVerify': FR_PENDING,
  'admin.systemTitle': FR_PENDING,
  'admin.systemLead': FR_PENDING,
  'admin.retentionTitle': FR_PENDING,
  'admin.sweepEvery': FR_PENDING,
  'admin.sweepOff': FR_PENDING,
  'admin.lastSweep': FR_PENDING,
  'admin.neverSwept': FR_PENDING,
  'admin.dueNow': FR_PENDING,
  'admin.dueNone': FR_PENDING,
  'admin.sweepDry': FR_PENDING,
  'admin.sweepRun': FR_PENDING,
  'admin.sweepBusy': FR_PENDING,
  'admin.sweepDone': FR_PENDING,
  'admin.sweepDryDone': FR_PENDING,
  'admin.deleteWorkspaceTitle': FR_PENDING,
  'admin.deleteWorkspaceWhat': FR_PENDING,
  'admin.deleteWorkspaceKeeps': FR_PENDING,
  'admin.deleteWorkspaceLabel': FR_PENDING,
  'admin.deleteWorkspaceCta': FR_PENDING,
  'admin.deleteWorkspaceMismatch': FR_PENDING,
  'admin.deleteWorkspaceDone': FR_PENDING,
  'admin.selectWorkspace': FR_PENDING,

  'notFound.title': FR_PENDING,
  'notFound.lead': FR_PENDING,
  'notFound.home': FR_PENDING,
}
